import { AccountInfo } from '@azure/msal-browser';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EmployeeType } from 'Components/Types';

interface CurrentUserState {
    currentUser: AccountInfo | null;
    currentEmployee: EmployeeType | null;
}

const initialState: CurrentUserState = {
    currentUser: null,
    currentEmployee: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCurrentUser(state:any, action: PayloadAction<AccountInfo|null>) {
            state.currentUser = action.payload;
        },
        setCurrentEmployee(state:any, action: PayloadAction<EmployeeType|null>) {
            state.currentEmployee = action.payload;
        }
    }
});
export const { setCurrentUser, setCurrentEmployee } = authSlice.actions;
export default authSlice.reducer;